import React from 'react';
import './Button.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

export const SubmitButton = ({ label, disabled, ...other }, context) => (
  <button {...other}
    type='submit'
    className={classNames('Button', 'btn-orange', (disabled ? 'disabled' : ''))}
    disabled={disabled}
  >
    {getLabel(context.locale, label)}
  </button>
);

SubmitButton.contextTypes = {
  locale: PropTypes.string,
};

export const InvertedButton = props => (
  <a {...props} className="Button btn-inverted">{props.children}</a>
);

const Button = ({ disabled, children, ...others }) => (
  <a {...others}
    disabled={disabled}
    className={classNames('Button', 'btn-orange', (disabled ? 'disabled' : ''))}
  >
    {children}
  </a>
);

export default Button;



// WEBPACK FOOTER //
// ./src/main/components/output/Button.js